// In-memory only. Never localStorage / sessionStorage (ADR-0005).
let accessToken: string | null = null;
let resetToken: string | null = null;
/** First-login activation token (`step=password_set`), kept apart from `resetToken` on purpose:
 *  `forgot-password/reset` and `activate/set-password` each reject the other's token step, so one
 *  shared slot would let a flow post a credential the API refuses (ADO 117536). */
let activationToken: string | null = null;

/** Notified whenever the access token changes, so a live socket can re-authenticate
 *  instead of outliving its credential (ADR-0025). Zero-arg on purpose: it is the
 *  `useSyncExternalStore` subscribe contract. */
const listeners = new Set<() => void>();

function notify(): void {
  // Copy first: a listener that (un)subscribes during notify must not mutate the set being walked.
  [...listeners].forEach((listener) => listener());
}

export const tokenStore = {
  getAccessToken: (): string | null => accessToken,
  setAccessToken: (token: string | null): void => {
    accessToken = token;
    notify();
  },
  getResetToken: (): string | null => resetToken,
  setResetToken: (token: string | null): void => {
    resetToken = token;
  },
  getActivationToken: (): string | null => activationToken,
  // No notify() — like setResetToken, this is not a session credential, so the socket's
  // access-token subscription (ADR-0025) must not react to it.
  setActivationToken: (token: string | null): void => {
    activationToken = token;
  },
  clear: (): void => {
    accessToken = null;
    resetToken = null;
    activationToken = null;
    notify();
  },
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
};
